var lib_core      = require("lib-core");
var FootprintSettingsModel = require("./footprintSettingsModel.js");

var PackageSettingsModel = function (data) {
    FootprintSettingsModel.call(this, data);
};
lib_core.inherit(PackageSettingsModel, FootprintSettingsModel);
PackageSettingsModel.$class = 'PackageSettingsModel';

module.exports = PackageSettingsModel;
